// extracted by mini-css-extract-plugin
module.exports = {"link":"_7a3fb80146--link--h_pGy"};